/** Find related content to the specified entity */

import type { Entity, Persisted, SearchFilter } from '@tunasong/schemas'
import { useMemo } from 'react'
import { allQueries } from './queries/index.js'
import { useAdvancedSearch } from './search.hook.js'

interface UseRelatedContentProps {
  entity?: Persisted<Entity>
  filter?: SearchFilter
  /** Search text. Defaults to the entity name. */
  query?: string
  debounceDelay?: number
}

export const useRelatedContent = ({ entity, filter, query: queryText, debounceDelay }: UseRelatedContentProps) => {
  const text = (queryText ?? entity?.name)?.trim()
  /** This must be stable */
  const query = useMemo(
    () =>
      text
        ? allQueries.relatedContent({
            query: text,
            filter,
          })
        : undefined,
    [text, filter]
  )
  /** Spec §7.1 promises this surface a local answer; it gets one only if it says what it meant */
  return useAdvancedSearch(query, {
    queryType: 'relatedContent',
    debounceDelay,
    intent: { query: text, types: filter?.types, tags: filter?.tags },
  })
}
